import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { fetchWithDefaults } from '../../config/fetchDefault';
import { useDispatch } from 'react-redux';
import { setLoadingGif } from '../../features/loadingSlice';
import InputTextField from '../../utilities/helperComponents/InputTextField'
import Dropdown from '../../utilities/helperComponents/Dropdown'
import PrimaryButton from '../../utilities/helperComponents/PrimaryButton';
import Icon from '../../assets/icons/icon';
import { setTags, setTagsToDelete, setTagsToMerge, updateDeleteTags, updateMergeTagNewName, updateMergeTags } from '../../features/tagSlice';
import { fetchQueue } from '../../utilities/leadFunctions';
import { formatYMD } from '../../utilities/dashFunction'

function AgentTags({setShowDeleteModal, setShowExistingTagModal, setShowMergeTagsModal}){
    const agentInfo = useSelector((state) => state.agent.userData);
    const loadingGif=useSelector((state) => state.loading.loading);
    const dispatch = useDispatch()

    const leads = useSelector( state => state.queue.wholeQueue)

    const tags = useSelector( state => state.tags.tags)
    const deleteTags = useSelector( state => state.tags.deleteTags )
    const mergeTags = useSelector( state => state.tags.mergeTags )
    const tagsToDelete = useSelector( state => state.tags.tagsToDelete )
    const tagsToMerge = useSelector ( state => state.tags.tagsToMerge )
    const mergeTagNewName = useSelector( state => state.tags.mergeTagNewName )

    const activeFilter = useSelector((state) => state.filters.activeFilter)

    const [displayTags, setDisplayTags] = useState([])
    const [searchFilter, setSearchFilter] = useState('')
    const [tableOptions, setTableOptions] = useState({
        start: 0,
        end: 10,
        size: 10,
        row: 1,
        maxRow: 100
    })
    const [editableTags, setEditableTags] = useState([])
    const [renamedTagMap, setRenamedTagsMap] = useState({})
    const [selectedTags, setSelectedTags] = useState([])

    const [toggleState, setToggleState] = useState({
        name: null,
        count: null,
        date: null
    })

    const pageOptions = [
        {
            label: '10',
            value: 10
        },
        {
            label: '15',
            value: 15
        },
        {
            label: '20',
            value: 20
        },
    ]

    const [agentTagData, setAgentTagData] = useState([])

    const updateTableSize = (size) => {
        const updatedOptions = {...tableOptions, size}

        updatedOptions.start = 0
        updatedOptions.end = updatedOptions.size

        setTableOptions(updatedOptions)
    }

    const getNextRow = () => {
        if(tableOptions.end >= agentTagData.length){
            return
        }

        const updatedOptions = {...tableOptions}

        let newStart = updatedOptions.end
        let newEnd = updatedOptions.end + updatedOptions.size

        console.log({newStart, len:agentTagData.length, size: updatedOptions.size, calc: agentTagData.length - updatedOptions.size})

        updatedOptions.start = newStart
        updatedOptions.end = Math.min(newEnd, agentTagData.length)

        console.log('getNextRow',{updatedOptions})
        setTableOptions(updatedOptions)
    }

    const getPrevRow = () => {
        if(tableOptions.start === 0){
            return
        }
        const  updatedOptions = {...tableOptions}

        let newStart = updatedOptions.start - updatedOptions.size
        let newEnd = updatedOptions.start

        updatedOptions.start = Math.max(newStart, 0)
        updatedOptions.end = Math.max(newEnd, updatedOptions.size)
        console.log('getPrevRow',{updatedOptions})
        setTableOptions(updatedOptions)
    }

    const renameTag = async (tag) => {
        const newName = renamedTagMap[tag.id]

        if(newName === undefined || newName === null){
            return
        }

        const existingTag = agentTagData.find(t => t.name === newName)

        if(existingTag){
            dispatch(setTagsToMerge([tag]))
            dispatch(updateMergeTagNewName(existingTag.name))

            setShowDeleteModal(false)
            setShowExistingTagModal(true)
            return
        }

        const requestOptions = {
            method: 'PATCH',
            body: JSON.stringify({
                tag: tag.id,
                content: newName
            })
        }

        try {
            const response = await fetchWithDefaults('/updateTag', requestOptions)

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            makeUneditable(tag.id)
            await getAgentTagData()
        } catch (error) {
            console.log('/updateTag',{requestOptions, error})
        }
    }

    const handleTagMerge = async () => {
        dispatch(setLoadingGif(true))

        try {
            let mergeTag = agentTagData.find(t => t.name === mergeTagNewName)
            const tagIds = tagsToMerge.map( t => t.id)

            if(!mergeTag){
                // add a new tag
                const requestOptions = {
                    method: 'POST',
                    body: JSON.stringify({
                        agent:agentInfo.agentId,
                        name: mergeTagNewName
                    })
                }

                const response = await fetchWithDefaults('/addNewTag', requestOptions)

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                mergeTag = await response.json()
            }

            // add new tag to the leads that have the tags in the tagsToMerge array
            const updateRequestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    tagId: mergeTag.id,
                    tagIds,
                    agent:agentInfo.agentId
                })
            }

            const response = await fetchWithDefaults('/addNewTagToPreviouslyTaggedLeads', updateRequestOptions)

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            // delete the tags in the tagsToMerge array
            const deleteRequestOptions = {
                method: 'DELETE',
                body: JSON.stringify({
                    tagIds,
                    agent:agentInfo.agentId
                })
            }

            const deleteResponse = await fetchWithDefaults('/deleteLeadTagAssociationForAgent', deleteRequestOptions)

            if (!deleteResponse.ok) {
                throw new Error('Network response was not ok')
            }

            const jsonData = await deleteResponse.json()
            const tagData = jsonData.data.map( t => { return {...t, created: Number(t.created)}})

            dispatch(setTagsToMerge([]))
            setSelectedTags([])
            setAgentTagData(tagData)
        } catch (error) {
            console.error(error)
        }

        dispatch(setLoadingGif(false))
    }

    const makeEditable = (tagId) => {
        const curEditList = [...editableTags]

        if(curEditList.includes(tagId)){
            return
        }

        curEditList.push(tagId)
        setEditableTags(curEditList)
    }

    const makeUneditable = (tagId) => {
        const curEditList = [...editableTags]

        if(!curEditList.includes(tagId)){
            return
        }
        setEditableTags(editableTags.filter(t => t !== tagId))
    }

    const handleSingleTagDeletion = (tag) => {
        dispatch(setTagsToDelete([tag]))
        setShowDeleteModal(true)
    }

    const handleSingleTagSelection = (tag, add = false) => {
        if(add){
            const updatedTags = [...selectedTags, tag.id]
            setSelectedTags(updatedTags)
        } else {
            const updatedTags = selectedTags.filter(id => id !== tag.id)
            setSelectedTags(updatedTags)
        }
    }

    const handleAllTagSelection = (add = false) => {
        if(add){
            const updatedTags = displayTags.map(t => t.id)
            setSelectedTags(updatedTags)
        } else {
            setSelectedTags([])
        }
    }

    const handleMultipleTagDeletion = () => {
        const deletionTagData = agentTagData.filter(t => selectedTags.includes(t.id))

        dispatch(setTagsToDelete(deletionTagData))
        setShowDeleteModal(true)
    }

    const handleMultipleTagMerge = () => {
        const mergeTagData = agentTagData.filter(t => selectedTags.includes(t.id))

        dispatch(setTagsToMerge(mergeTagData))
        setShowMergeTagsModal(true)
    }

    const deleteMultipleTags = async () => {
        const tagIds = tagsToDelete.map( t => t.id)

        try {
            // delete the tags in the tagsToMerge array
            const deleteRequestOptions = {
                method: 'DELETE',
                body: JSON.stringify({
                    tagIds,
                    agent:agentInfo.agentId
                })
            }

            const deleteResponse = await fetchWithDefaults('/deleteLeadTagAssociationForAgent', deleteRequestOptions)

            if (!deleteResponse.ok) {
                throw new Error('Network response was not ok')
            }

            const jsonData = await deleteResponse.json()
            const tagData = jsonData.data.map( t => { return {...t, created: Number(t.created)}})

            dispatch(setTagsToDelete([]))
            setSelectedTags([])
            setAgentTagData(tagData)
        } catch (error) {
            console.log(error)
        }
    }

    const updateToggle = (field) => {
        if(toggleState[field] === undefined){
            return
        }

        const newState = {...toggleState}

        for (const [key, value] of Object.entries(toggleState)) {
            if(key === field){
                if(value === null){
                    newState[key] = true
                } else {
                    newState[key] = !value
                }
            } else {
                newState[key] = null
            }
        }

        setToggleState(newState)
    }

    useEffect(()=>{
        let newTagData = agentTagData
                            .filter(t => {
                                if(!searchFilter){
                                    return true
                                }

                                return t.name.includes(searchFilter)
                            })
                            .toSorted((a,b) => {
                                const {count, name, date} = toggleState
                                if(count !== null){
                                    if(count === true){
                                        return a.lead_count - b.lead_count
                                    } else if(count === false) {
                                        return b.lead_count - a.lead_count
                                    }
                                } else if(name !== null){
                                    const nameA = a.name.toUpperCase()
                                    const nameB = b.name.toUpperCase()
                                    if(name === true){
                                        return nameA.localeCompare(nameB)
                                    } else if(name === false) {
                                        return nameB.localeCompare(nameA)
                                    }
                                } else if(date !== null){
                                    if(date === true){
                                        return a.created - b.created
                                    } else if(date === false) {
                                        return b.created - a.created
                                    }
                                }

                                return 0
                            })
                            .slice(tableOptions.start, tableOptions.end)
        setDisplayTags(newTagData)
    }, [tableOptions, leads, searchFilter, toggleState, agentTagData])

    useEffect(()=>{
        if(deleteTags === true){
            deleteMultipleTags()
            dispatch(updateDeleteTags(false))
            setShowDeleteModal(false)
        }
    }, [deleteTags])

    useEffect(()=>{
        if(mergeTags === true){
            handleTagMerge()
            dispatch(updateMergeTags(false))
            setShowExistingTagModal(false)
            setShowMergeTagsModal(false)
        }
    }, [mergeTags])

    const getAgentTagData = async () => {
        const response = await fetchWithDefaults(`/agentTaggedLeadCounts?agent=${agentInfo.agentId}`)

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const jsonData = await response.json()
        const tagData = jsonData.data.map( t => { return {...t, created: Number(t.created)}})
        setAgentTagData(tagData)
    }

    const updateReduxFields = async () => {
        await fetchQueue(agentInfo.agentId, dispatch, activeFilter) // updates tag data in queue slice

        // update tag data in tag slice
        const masterTags = tags.filter( t => t.id && t.id.startsWith('tag_master_'))

        const updatedTags = agentTagData.map( t => {
            const {name, id, workflow, reminder, single_send} = t

            return {single: single_send, name, id, workflow, reminder}
        })

        dispatch(setTags([...masterTags,...updatedTags]))
    }

    useEffect(()=>{
        getAgentTagData()
    }, [])

    useEffect(()=>{
        updateReduxFields()
    }, [agentTagData])

    return (
        <>
            <div style={{ width: '100%', margin: '20px auto 85px', maxWidth: '763px' }}>
                <div style={{ width: '100%', paddingLeft: 24, paddingRight: 24, paddingTop: 16, paddingBottom: 16, background: '#F1F1F1', borderBottom: '2px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 40, display: 'inline-flex', borderRadius: '5px 5px 0px 0px', }}>
                    <div style={{ flex: '1 1 0', color: '#2F2F2F', fontSize: 20, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word' }}>Manage Tags</div>
                    <div style={{ justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'flex' }} />
                </div>

                <div style={{ width: '100%', height: '100%', padding: 24, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex', background: 'white', borderRadius: ' 0px 0px 5px 5px', }}>
                    <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 40, display: 'flex' }}>
                        <div style={{ width: '100%', height: 13, color: '#2F2F2F', fontSize: 18, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word' }}>My Tags</div>
                    </div>

                    <div style={{ width: '100%', justifyContent: 'flex-start', alignItems: 'flex-end', gap: 109, display: 'inline-flex' }}>
                        <div style={{ width: '100%', alignSelf: 'stretch', height: 86, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'flex' }}>
                            <div style={{ alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-end', gap: 109, display: 'inline-flex' }}>
                                <InputTextField
                                    inputLabel='Search for tag name'
                                    inputValue={searchFilter}
                                    leftIconConfigs={{icon: 'q-search', rotate: true, color: '#707070'}}
                                    changeHandler={ e => setSearchFilter(e.target.value)}
                                    disabled={loadingGif}
                                />
                                <div style={{height: 40, justifyContent: 'flex-start', alignItems: 'flex-end', gap: 15, display: 'flex'}}>
                                    {/* <div style={{ width: '100%', height: '100%', paddingLeft: 16, paddingRight: 16, paddingTop: 10, paddingBottom: 10, background: '#E4E4E4', borderRadius: 6, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'inline-flex' }}> */}
                                            <PrimaryButton
                                                buttonClass={selectedTags.length === 0 ? null : 'q-destructive-button'}
                                                buttonLabel='Delete Tags'
                                                disabled={selectedTags.length === 0 || loadingGif}
                                                leftIconConfigs={{icon: 'trash-q', rotate: true, color: 'white'}}
                                                clickHandler={ _ => handleMultipleTagDeletion() }
                                            />
                                    {/* </div> */}
                                    {/* <div style={{paddingLeft: 16, paddingRight: 16, paddingTop: 10, paddingBottom: 10, background: '#E4E4E4', borderRadius: 6, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex'}}> */}
                                        <PrimaryButton
                                            buttonLabel='Merge Tags'
                                            disabled={selectedTags.length === 0 || loadingGif}
                                            leftIconConfigs={{icon: 'q-icon-stroke', rotate: false, color: '#fff', viewBox: '0 0 18 18', size: 18, height: 18}}
                                            clickHandler={ _ => handleMultipleTagMerge() }
                                        />
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{width: '100%', background: 'white', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 6, overflow: 'hidden', border: '1px #E4E4E4 solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                        <div style={{width: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                            <div style={{width: 58, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                                <div style={{width: 58, height: 56, paddingTop: 16, paddingBottom: 16, paddingLeft: 12, background: '#F8F8F8', borderBottom: '1px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'inline-flex'}}>
                                    <div style={{width: 36, height: 36, padding: 8, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                        <div style={{borderRadius: 4, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', display: 'inline-flex'}}>
                                            <div>
                                                <input onChange={e => handleAllTagSelection(e.target.checked)} type='checkbox' disabled={loadingGif}></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {displayTags.map((tag, index) => (
                                    <div key={`tags_checkbox_${index}`} style={{ width: 58, height: 72, paddingTop: 16, paddingBottom: 16, paddingLeft: 12, borderBottom: '1px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'inline-flex' }}>
                                        <div style={{ width: 36, height: 36, padding: 8, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                            <div style={{ borderRadius: 4, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
                                                <div>
                                                    <input
                                                        onChange={e => handleSingleTagSelection(tag, e.target.checked)}
                                                        type='checkbox'
                                                        checked={selectedTags.includes(tag.id)}
                                                        disabled={loadingGif}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div style={{width: 292, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                                <div onClick={ _ => updateToggle('name')} style={{alignSelf: 'stretch', height: 56, paddingLeft: 24, paddingRight: 24, paddingTop: 16, paddingBottom: 16, background: '#F8F8F8', borderBottom: '1px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'inline-flex', cursor: 'pointer'}}>
                                    <div style={{justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex'}}>
                                        <div style={{color: '#2F2F2F', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '700',  wordWrap: 'break-word'}}>Tag Name</div>
                                        <Icon name='q-switch-vertical' size={20} adjust="fontello" color='#F95951' viewBox="0 0 16 16" strokeOptions={{stroke: 'rgb(208,208,208)', width: '1.33333', lineCap: 'round', lineJoin: 'round'}} />
                                    </div>
                                </div>
                                {displayTags.map((tag, index) => (
                                    <div key={`tag_name_${index}`} style={{alignSelf: 'stretch', height: 72, paddingLeft: 24, paddingRight: 24, paddingTop: 16, paddingBottom: 16, borderBottom: '1px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex'}}>
                                        {editableTags.includes(tag.id) ? (
                                            <>
                                                <div style={{ flex: '1 1 0', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'inline-flex' }}>
                                                        <div style={{ flex: '1 1 0', height: 10, justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'flex' }}>
                                                            <InputTextField
                                                                inputValue={tag.name}
                                                                changeHandler={ e => setRenamedTagsMap(preVals =>({...preVals, ...{[tag.id]: e.target.value}}))}
                                                                disabled={loadingGif}
                                                            />
                                                        </div>
                                                </div>
                                                <div style={{ height: 20, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 6, display: 'flex' }}>
                                                    <div onClick={e => makeUneditable(tag.id)} style={{ width: 20, height: 20, position: 'relative', cursor: 'pointer' }}>
                                                        <Icon name={'x-close-q'} color='#707070' size={16} adjust="fontello" />
                                                    </div>
                                                    <div onClick={e => renameTag(tag)} style={{ width: 20, height: 20, position: 'relative', cursor: 'pointer' }}>
                                                        <Icon className={'qCheckmark'} name={'checkmark-q'} color='#46C3B2' size={20} height={20} adjust="fontello" />
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div style={{color: '#2F2F2F', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400',  wordWrap: 'break-word'}}>{tag.name}</div>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div style={{width: 171, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                                <div onClick={ _ => updateToggle('count') } style={{width: 171, height: 56, paddingLeft: 12, paddingRight: 12, paddingTop: 16, paddingBottom: 16, background: '#F8F8F8', borderBottom: '1px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'inline-flex', cursor: 'pointer'}}>
                                    <div style={{justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex'}}>
                                        <div style={{color: '#2F2F2F', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '700',  wordWrap: 'break-word'}}>Applied</div>
                                        <Icon name='q-switch-vertical' size={20} adjust="fontello" color='#F95951' viewBox="0 0 16 16" strokeOptions={{stroke: 'rgb(208,208,208)', width: '1.33333', lineCap: 'round', lineJoin: 'round'}} />
                                    </div>
                                </div>
                                {displayTags.map((tag, index) => (
                                    <div key={`applied_tag_${index}`} style={{alignSelf: 'stretch', height: 72, paddingLeft: 12, paddingRight: 12, paddingTop: 16, paddingBottom: 16, borderBottom: '1px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex'}}>
                                        <div style={{color: '#2F2F2F', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400',  wordWrap: 'break-word'}}>{tag.lead_count} {tag.lead_count === 1 ? 'Lead' : 'Leads'}</div>
                                    </div>
                                ))}
                            </div>
                            <div style={{width: 198, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                                <div onClick={ _ => updateToggle('date') } style={{alignSelf: 'stretch', height: 56, paddingLeft: 12, paddingRight: 12, paddingTop: 16, paddingBottom: 16, background: '#F8F8F8', borderBottom: '1px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'inline-flex', cursor: 'pointer'}}>
                                    <div style={{justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex'}}>
                                        <div style={{color: '#2F2F2F', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '700',  wordWrap: 'break-word'}}>Date Created</div>
                                        <Icon name='q-switch-vertical' size={20} adjust="fontello" color='#F95951' viewBox="0 0 16 16" strokeOptions={{stroke: 'rgb(208,208,208)', width: '1.33333', lineCap: 'round', lineJoin: 'round'}} />
                                    </div>
                                </div>
                                {displayTags.map((tag, index) => (
                                    <div key={`date_created_${index}`} style={{alignSelf: 'stretch', height: 72, paddingLeft: 12, paddingRight: 12, paddingTop: 16, paddingBottom: 16, borderBottom: '1px #E4E4E4 solid', justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex'}}>
                                        <div style={{color: '#2F2F2F', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400',  wordWrap: 'break-word'}}>{formatYMD(tag.created, agentInfo.timezone)}</div>
                                    </div>
                                ))}
                            </div>
                            <div style={{width: 107, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                                <div style={{width: 107, height: 56, paddingTop: 16, paddingBottom: 16, paddingLeft: 16, paddingRight: 24, background: '#F8F8F8', borderBottom: '1px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'inline-flex'}}>
                                    <div style={{justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex'}}>
                                        <div style={{color: '#2F2F2F', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '700',  wordWrap: 'break-word'}}>Actions</div>
                                    </div>
                                </div>
                                {displayTags.map((tag, index) => (
                                    <div key={`actions_${index}`} style={{width: 107, height: 72, paddingLeft: 6, paddingRight: 6, paddingTop: 16, paddingBottom: 16, borderBottom: '1px #E4E4E4 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'inline-flex'}}>
                                        <div onClick={e => loadingGif ? null : makeEditable(tag.id)} style={{width: 40, height: 40, justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex', cursor: 'pointer'}}>
                                            <div style={{paddingTop: 6, paddingBottom: 6, justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex'}}>
                                                <div style={{width: 18, height: 30, position: 'relative'}}>
                                                    <div style={{width: 14.50, height: 14.50, left: 1.88, top: 1.63, position: 'absolute'}}>
                                                        <Icon name='q-pencil' height={18} size={20} adjust="fontello" color='none' viewBox="0 0 18 18" strokeOptions={{stroke: '#46C3B2', width: '2', lineCap: 'round', lineJoin: 'round'}} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div onClick={e => loadingGif ? null : handleSingleTagDeletion(tag)} style={{width: 40, height: 40, justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex', cursor: 'pointer'}}>
                                            <div style={{paddingTop: 6, paddingBottom: 6, justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex'}}>
                                                <div style={{width: 18, height: 18, position: 'relative'}}>
                                                    <div style={{width: 13.50, height: 13.50, left: 2.25, top: 2.25, position: 'absolute',  transform: 'rotate(180deg)'}}>
                                                        <Icon name='trash-q' size={20} adjust="fontello" color='#DE3F35' viewBox="0 0 1024 700" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div style={{width: '100%', background: 'white', justifyContent: 'flex-end', alignItems: 'center', gap: 36, display: 'inline-flex'}}>
                        <div style={{justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'flex'}}>
                            <div style={{color: 'black', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', letterSpacing: 0.06, wordWrap: 'break-word'}}>Rows per page:</div>
                            <div style={{overflow: 'hidden',justifyContent: 'center', alignItems: 'center', gap: 4, display: 'flex'}}>
                                <Dropdown
                                    disabled={loadingGif}
                                    options={pageOptions}
                                    changeHandler={e => updateTableSize(parseInt(e.target.value))}
                                    inputValue={tableOptions.size}
                                />
                            </div>
                        </div>
                        <div style={{color: 'black', fontSize: 13, fontFamily: 'Montserrat', fontWeight: '500',  letterSpacing: 0.06, wordWrap: 'break-word'}}>{tableOptions.start+1} – {Math.min(tableOptions.end, agentTagData.length)} of {agentTagData.length}</div>
                        <div style={{justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'flex'}}>
                            <div onClick={e => loadingGif ? null : getPrevRow()}  style={{padding: 10, background: '#D0D0D0', borderRadius: 100, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex', cursor: 'pointer'}}>
                                <div style={{width: 18, height: 18, position: 'relative'}}>
                                    <div style={{width: 6, height: 10, position: 'absolute'}}>
                                        <Icon name='q-chevron-left' height={18} size={18} adjust="fontello" color='#D0D0D0' viewBox="0 0 16 16" strokeOptions={{stroke:"white", width:"2",lineCap:"round",lineJoin:"round"}}/>
                                    </div>
                                </div>
                            </div>
                            <div onClick={e => loadingGif ? null : getNextRow()} style={{padding: 10, background: '#D0D0D0', borderRadius: 100, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'flex', cursor: 'pointer'}}>
                                <div style={{width: 18, height: 18, position: 'relative'}}>
                                    <div style={{width: 6, height: 10, position: 'absolute'}}>
                                        <Icon name='q-chevron-right' height={18} size={18} adjust="fontello" color='#D0D0D0' viewBox="0 0 16 16" strokeOptions={{stroke:"white", width:"2",lineCap:"round",lineJoin:"round"}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AgentTags;